var React = require('react');

function BoldChevronUp (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M8.237 22.237 16 14.475l7.763 7.762 2.474-2.474L16 9.525 5.763 19.763l2.474 2.474Z","key":0}),React.createElement("path",{"d":"M0 0v32h32V0H0Z","style":{"fill":"none"},"key":1})]);
}

BoldChevronUp.defaultProps = {"xmlSpace":"preserve","style":{"fillRule":"evenodd","clipRule":"evenodd","strokeLinejoin":"round","strokeMiterlimit":"2"},"viewBox":"0 0 32 32"};

module.exports = BoldChevronUp;

BoldChevronUp.default = BoldChevronUp;
